import React from 'react'
import Form from 'react-bootstrap/Form';
import { useState } from 'react';

function Drumpad() {

  const bankOne = [ //Sound bank 1
    {
      keyCode: 81,
      keyTrigger: 'Q',
      id: 'Heater-1',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-1.mp3'
    },
    {
      keyCode: 87,
      keyTrigger: 'W',
      id: 'Heater-2',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-2.mp3'
    },
    {
      keyCode: 69,
      keyTrigger: 'E',
      id: 'Heater-3',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-3.mp3'
    },
    {
      keyCode: 65,
      keyTrigger: 'A',
      id: 'Heater-4',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-4_1.mp3'
    },
    {
      keyCode: 83,
      keyTrigger: 'S',
      id: 'Clap',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Heater-6.mp3'
    },
    {
      keyCode: 68,
      keyTrigger: 'D',
      id: 'Open-HH',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Dsc_Oh.mp3'
    },
    {
      keyCode: 90,
      keyTrigger: 'Z',
      id: "Kick-n'-Hat",
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Kick_n_Hat.mp3'
    },
    {
      keyCode: 88,
      keyTrigger: 'X',
      id: 'Kick',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/RP4_KICK_1.mp3'
    },
    {
      keyCode: 67,
      keyTrigger: 'C',
      id: 'Closed-HH',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Cev_H2.mp3'
    }
  ];

  const bankTwo = [ //Sound bank 2
    {
      keyCode: 81,
      keyTrigger: 'Q',
      id: 'Chord-1',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_1.mp3'
    },
    {
      keyCode: 87,
      keyTrigger: 'W',
      id: 'Chord-2',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_2.mp3'
    },
    {
      keyCode: 69,
      keyTrigger: 'E',
      id: 'Chord-3',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Chord_3.mp3'
    },
    {
      keyCode: 65,
      keyTrigger: 'A',
      id: 'Shaker',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Give_us_a_light.mp3'
    },
    {
      keyCode: 83,
      keyTrigger: 'S',
      id: 'Open-HH',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Dry_Ohh.mp3'
    },
    {
      keyCode: 68,
      keyTrigger: 'D',
      id: 'Closed-HH',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Bld_H1.mp3'
    },
    {
      keyCode: 90,
      keyTrigger: 'Z',
      id: 'Punchy-Kick',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/punchy_kick_1.mp3'
    },
    {
      keyCode: 88,
      keyTrigger: 'X',
      id: 'Side-Stick',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/side_stick_1.mp3'
    },
    {
      keyCode: 67,
      keyTrigger: 'C',
      id: 'Snare',
      url: 'https://s3.amazonaws.com/freecodecamp/drums/Brk_Snr.mp3'
    }
  ];


    document.addEventListener('keydown', (event) => {
      playSound(event.key.toUpperCase()) // Catch wich key is pressed and call the play sound function with that ID
    });
  

  function playSound(selector, id) {
    const audio = document.getElementById(selector); //Get the id / key pressed
    audio.volume = range / 100; //Change the volume
    setCurrentId(id) //Set name of the currently pressed sound
    audio.currentTime = 0;
    audio.play(); // Play the audio
  }



  const [range, setRange] = useState("100"); // Use State to get the range value
  const [currentId, setCurrentId] = useState(""); // Use State to get and set current sound name
  const [currentBank, setCurrentBank] = useState(bankOne); // use State to get and set current bank

  return (
    <div className='container'>
      <div className='drumpad-container'>
        {currentBank.map((drumpad) =>
          <div className='drum-pad' id={drumpad.url} key={drumpad.keyCode} onClick={() => playSound(drumpad.keyTrigger, drumpad.id)} >
            {drumpad.keyTrigger}
            <audio src={drumpad.url} id={drumpad.keyTrigger}></audio>
          </div>)} {/*Map each button*/}
      </div>
      <div className='controls'>
        <Form.Label>Volume</Form.Label>
        <Form.Range onChange={e => setRange(e.target.value)} className="vol-bar"/>
        <p>{currentId}</p>
        <button onClick={() => setCurrentBank(bankOne)}>Bank 1</button>
        <button onClick={() => setCurrentBank(bankTwo)}>Bank 2</button>
      </div>
    </div>

  )
}

export default Drumpad